import React from "react";
import styled from "@emotion/styled";

import {
  Grid,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
  // FormControlLabel,
  // Switch,
  Button,
} from "@mui/material";
import Rating from "@mui/material/Rating";
import { spacing } from "@mui/system";
import DownloadIcon from "@mui/icons-material/Download";
import { CSVLink } from "react-csv";
const Paper = styled(MuiPaper)(spacing);

const Spacer = styled.div`
  flex: 1 1 50%;
`;
// srno date assignedAgent contact rating feedbackComments
function createData(
  date,
  assignedAgent,
  contact,
  rating,
  feedbackComments,
  responseStatus
) {
  return {
    date,
    assignedAgent,
    contact,
    rating,
    feedbackComments,
    responseStatus,
  };
}

var rows = [];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => ({
    el,
    index,
  }));
  stabilizedThis.sort((a, b) => {
    const order = comparator(a.el, b.el);
    if (order !== 0) return order;
    return a.index - b.index;
  });
  return stabilizedThis.map((element) => element.el);
}

const headCells = [
  {
    id: "srno",
    numeric: false,
    disablePadding: true,
    label: "Sr.No.",
  },
  {
    id: "date",
    numeric: false,
    disablePadding: true,
    label: "Date",
  },
  {
    id: "assignedAgent",
    numeric: false,
    disablePadding: true,
    label: "Assigned Agent",
  },
  {
    id: "contact",
    numeric: false,
    disablePadding: true,
    label: "Contact",
  },
  {
    id: "rating",
    numeric: false,
    disablePadding: true,
    label: "Rating",
  },
  {
    id: "feedbackComments",
    numeric: false,
    disablePadding: true,
    label: "Feedback Comments",
  },
  {
    id: "responseStatus",
    numeric: false,
    disablePadding: true,
    label: "Response Status",
  },
];
var HeaderName = [];
headCells.map(
  (item) => !!item.id && item.id !== "srno" && HeaderName.push(item.id)
);

const EnhancedTableHead = (props) => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={"checkbox"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  // const { handleChangeDense, dense } = props;
  var [timeStamp, setTimeStamp] = React.useState(Number(new Date()));
  return (
    <Toolbar>
      <div>
        <Typography variant="h6" id="tableTitle" color="primary">
          CSAT Overview
        </Typography>
      </div>
      <Spacer />
      <div>
        <Button variant="contained" color="primary" mr={10}>
          <DownloadIcon />
          <CSVLink
            data={props.rows}
            headers={HeaderName}
            className="whiteColor"
            onClick={() => {
              setTimeStamp(Number(new Date()));
            }}
            filename={`CSATDetailsByDateReports${timeStamp}.csv`}
          >
            Download Report
          </CSVLink>
        </Button>
        {/* <FormControlLabel
          control={<Switch checked={dense} onChange={handleChangeDense} />}
          label="Dense padding"
          ml={10}
        /> */}
      </div>
    </Toolbar>
  );
};

function EnhancedTable({ csatReportdata }) {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  var [conversationData, setConversationData] = React.useState([]);

  React.useEffect(() => {
    !!csatReportdata && !!csatReportdata.csatDetails
      ? setConversationData(csatReportdata.csatDetails)
      : setConversationData([]);
    setDense(true);
  }, [csatReportdata]);

  rows = !!conversationData
    ? conversationData.map((item, i) =>
        createData(
          !!item.created_at ? item.created_at.split("T")[0] : "",
          item.agentData.length > 0 ? item.agentData[0].displayname : "",
          item.contactData.length > 0 ? item.contactData[0].name : "",
          parseInt(item.status) === 1 ? item.rating : 0,
          !!item.feedback ? item.feedback : "",
          parseInt(item.status) === 1 ? "Yes" : "No"
        )
      )
    : [];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // const emptyRows =
  //   rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
  let emptyRows = rowsPerPage - (rowsPerPage + 1);

  return (
    <div>
      <Paper>
        <EnhancedTableToolbar
          numSelected={selected.length}
          handleChangeDense={handleChangeDense}
          dense={dense}
          rows={rows}
        />
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.date);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  // date, channel, assignee, contact, contactNo
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.date)}
                      key={row.date}
                      selected={isItemSelected}
                    >
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="checkbox"
                      >
                        {/* {index + 1} */}
                        {page === 0
                          ? index + 1
                          : index + 1 + rowsPerPage * page}
                      </TableCell>
                      <TableCell>{row.date}</TableCell>
                      <TableCell>{row.assignedAgent}</TableCell>
                      <TableCell>{row.contact}</TableCell>
                      <TableCell>
                        {
                          <Rating
                            name="simple-controlled"
                            value={row.rating}
                            style={{ fontSize: "20px" }}
                            disabled={false}
                          />
                        }
                      </TableCell>
                      <TableCell>{row.feedbackComments}</TableCell>
                      <TableCell>
                        {row.responseStatus === "Yes" ? (
                          <span style={{ color: "#00C900" }}> Yes</span>
                        ) : (
                          <span style={{ color: "#C90000" }}> No</span>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 8]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function CSATDetailsTab({ csatReportdata }) {
  return (
    <React.Fragment>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <EnhancedTable csatReportdata={csatReportdata} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default CSATDetailsTab;
